<template>
    <div class="app-footer">
        <div class="app-footer__inner">
            <div class="app-footer-left">
                <FooterDots/>
            </div>
            <div class="app-footer-right">
                <FooterMenu/>
            </div>
        </div>
    </div>
</template>

<script>
import FooterDots from '@themes/architectui/src/Layout/Components//Footer/FooterDots.vue';
import FooterMenu from '@themes/architectui/src/Layout/Components//Footer/FooterMenu.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEllipsisV,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faEllipsisV,
);
export default {
  name: 'Footer',
  components: {
    FooterDots,
    FooterMenu,
  },
};
</script>
